export default {
  INVESTMENT_PRODUCT_FUND_TYPE_REPOSITORY: Symbol.for('INVESTMENT_PRODUCT_FUND_TYPE_REPOSITORY'),
  GET_INVESTMENT_PRODUCT_FUND_TYPE_QUERY: Symbol.for('GET_INVESTMENT_PRODUCT_FUND_TYPE_QUERY'),
  INVESTMENT_PRODUCT_FUND_TYPE_STATE_MANAGER: Symbol.for('INVESTMENT_PRODUCT_FUND_TYPE_STATE_MANAGER'),
};
